import React from "react";
import { Helmet } from "react-helmet";
import FirstSection from "./Components/FirstSection";
import SecondSection from "./Components/SecondSection";

function index() {
  return (
    <>
      <Helmet>
        <title>داستان ما | نیکوتن</title>
        <meta name="description" content={"نیک کلاب"} />
        <link rel="canonical" href={window.origin + `/clup}`} />
      </Helmet>
      <div className="background-gray">
        <div className="container padding-y-section">
          <FirstSection />
          <SecondSection />
        </div>
      </div>
    </>
  );
}

export default index;
